import React from "react";
import { StyledCheckmarkControl } from "./styled";

function CheckmarkControl({
  className = "",
  fontSize = 12,
  primaryColor = "var(--rms-v2-primary)",
  selected = false,
  size = 18,
  style,
}) {
  return (
    <StyledCheckmarkControl
      aria-hidden="true"
      className={className}
      fontSize={fontSize}
      primaryColor={primaryColor}
      selected={selected}
      size={size}
      style={style}
    >
      {selected ? "✓" : ""}
    </StyledCheckmarkControl>
  );
}

export default CheckmarkControl;
